import { useQuery } from 'react-query';
import {
  getRosterQualificationsPreferred,
  RosterQualificationsPreferred
} from 'RestAPIs/qualifications';

const useGetRosterQualificationsPreferred = ({
  costCenterId
}: RosterQualificationsPreferred) => {
  const { data, isFetching, isError, refetch, isLoading } = useQuery(
    ['rosterQualificationsPreferred', 'list', costCenterId],
    async () => {
      const { data } = await getRosterQualificationsPreferred({ costCenterId });
      return data;
    }
  );
  return { data, isFetching, isError, refetch, isLoading };
};

export default useGetRosterQualificationsPreferred;
